import { useEffect } from 'react';
import {
  DEFAULT_DOCUMENT_TITLE,
  formatDocumentTitle,
} from '../../constants/documentTitle';

type UseDocumentTitleOptions = {
  restoreOnUnmount?: boolean;
};

export function useDocumentTitle(
  pageTitle: string = DEFAULT_DOCUMENT_TITLE,
  options?: UseDocumentTitleOptions
) {
  const documentTitle =
    pageTitle === DEFAULT_DOCUMENT_TITLE
      ? DEFAULT_DOCUMENT_TITLE
      : formatDocumentTitle(pageTitle);

  const restoreOnUnmount =
    options?.restoreOnUnmount ?? pageTitle !== DEFAULT_DOCUMENT_TITLE;

  useEffect(() => {
    document.title = documentTitle;

    if (!restoreOnUnmount) {
      return;
    }

    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [documentTitle, restoreOnUnmount]);
}
